/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Aviso tipo toast. En /cart usa el contenedor con estilos del tema;
// en cualquier otra página crea un toast flotante (así sirve también en producto).
window.showCartPageAlert = (type, message) => {
    if (!message) return

    let el = document.querySelector('#cart-page-alert')
    if (!el) {
        el = document.createElement('div')
        el.id = 'cart-page-alert'
        el.setAttribute('role', 'status')
        el.setAttribute('aria-live', 'polite')
        el.style.cssText = 'position:fixed;top:calc(12px + env(safe-area-inset-top));left:50%;transform:translateX(-50%);z-index:1080;width:min(100% - 24px,560px);display:flex;align-items:center;gap:9px;padding:12px 16px;border-radius:12px;font-size:14px;font-weight:600;box-shadow:0 8px 24px rgba(0,0,0,.14)'
        const icon = document.createElement('span'); icon.className = 'ec-alert-icon'; icon.setAttribute('aria-hidden', 'true')
        const txt = document.createElement('span'); txt.className = 'ec-alert-text'
        el.appendChild(icon); el.appendChild(txt)
        document.body.appendChild(el)
        el.dataset.floating = 'true'
    }

    el.querySelector('.ec-alert-text').textContent = message

    if (el.dataset.floating === 'true') {
        // Toast flotante fuera de /cart: estilos inline por tipo
        const palette = {
            success: ['#ecfaf1', '#1b7a43', '#b9e6c9', '✓'],
            error:   ['#fdeceb', '#b02a20', '#f3c6c2', '⚠'],
            info:    ['#eef6ff', '#1d4ed8', '#cfe2ff', 'ℹ']
        }
        const c = palette[type] || palette.info
        el.style.background = c[0]
        el.style.color = c[1]
        el.style.border = '1px solid ' + c[2]
        el.querySelector('.ec-alert-icon').textContent = c[3]
    } else {
        // En /cart: clases con estilos definidos en la sección
        el.className = 'ec-alert ec-alert-' + type
    }

    el.removeAttribute('hidden')
    clearTimeout(window.__cartAlertTimer)
    window.__cartAlertTimer = setTimeout(() => el.setAttribute('hidden', 'hidden'), 3500)
}

function parseHTML(text) {
    return new DOMParser().parseFromString(text, 'text/html')
}

/**
 * Recorta el HTML al cajon del carrito antes de parsearlo.
 *
 * Si el recorte no sale como se espera --porque cambio el marcado-- se vuelve
 * al documento completo. Vale mas una pasada lenta que un carrito que no se
 * actualiza.
 */
function parseSoloCajon(text) {
    const ini = text.indexOf('<div id="offcanvas-cart-wrapper"')
    if (ini === -1) return parseHTML(text)

    // El <script> del propio cajon va inmediatamente despues del marcado.
    let fin = text.indexOf('<script', ini)
    if (fin === -1) fin = text.length

    const doc = parseHTML(text.slice(ini, fin))
    return doc.querySelector('#offcanvas-cart .offcanvas-body') ? doc : parseHTML(text)
}

/**
 * Trae el cajon recien renderizado.
 *
 * Pide /search?view=cajon, una plantilla con `layout none` que devuelve solo
 * el carrito: 48 KB frente a los 530 de la portada o los 337 de una ficha de
 * producto. Antes se descargaba la pagina entera para sacar de ahi cuatro
 * nodos.
 *
 * Si esa ruta fallara --plantilla renombrada, un proxy que la bloquee, un
 * despliegue a medias-- se vuelve a pedir la pagina actual, que es exactamente
 * lo que se hacia antes. El carrito nunca se queda sin actualizar por esto.
 *
 * En /cart se pide la pagina completa desde el principio: alli hacen falta
 * #cart y #enigma-cart-recs, que esa plantilla no incluye.
 */
async function documentoDelCarrito(esPaginaCarrito) {
    if (!esPaginaCarrito) {
        try {
            const r = await fetch('/search?view=cajon', { headers: { Accept: 'text/html' } })
            if (r.ok) {
                const doc = parseHTML(await r.text())
                if (doc.querySelector('#offcanvas-cart .offcanvas-body')) return doc
            }
        } catch (e) { /* cae al plan B */ }
    }

    const r = await fetch(window.location.href)
    const texto = await r.text()
    return esPaginaCarrito ? parseHTML(texto) : parseSoloCajon(texto)
}

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async (response) => {
    const offcanvasCart = document.querySelector('#offcanvas-cart')
    const cartPage = document.querySelector('#cart')

    offcanvasCart?.classList.add('loading')
    cartPage?.classList.add('loading')

    // Abrir el cajon en cuanto Shopify confirma el alta, sin esperar al
    // segundo viaje que trae el marcado. Son dos peticiones en serie --add.js
    // y el cajon-- de medio segundo larga cada una, y hasta ahora el cliente
    // pasaba ese segundo y medio sin ninguna senal de que su clic hubiera
    // hecho algo. El cuerpo se queda atenuado por la clase `loading` mientras
    // llega el contenido nuevo.
    //
    // Solo si ya habia articulos: con el carrito vacio el cajon abriria
    // diciendo "tu carrito esta vacio" justo despues de agregar algo, que es
    // peor que esperar.
    const cajonConArticulos = offcanvasCart && !offcanvasCart.querySelector('#offcanvas-cart-empty')
    if (response.ok && response.url.includes('add.js') && cajonConArticulos && !cartPage) {
        bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart).show()
    }

    try {
        const newDocument = await documentoDelCarrito(!!cartPage)

        const newBody = newDocument.querySelector('#offcanvas-cart .offcanvas-body')
        const currentBody = offcanvasCart?.querySelector('.offcanvas-body')
        const drawerScroll = currentBody ? currentBody.scrollTop : 0
        if (currentBody && newBody) {
            currentBody.replaceWith(newBody)
            newBody.scrollTop = drawerScroll // preserva el scroll del drawer tras el re-render
        }

        // La cabecera lleva el contador de articulos y queda fuera del cuerpo
        // y del pie, asi que ninguno de los reemplazos la alcanza: sin esto se
        // quedaria con el numero de antes del cambio.
        const rotulo = offcanvasCart?.querySelector('#offcanvas-cart-label')
        const nuevoRotulo = newDocument.querySelector('#offcanvas-cart-label')
        if (rotulo && nuevoRotulo) rotulo.replaceWith(nuevoRotulo)

        const currentFooter = offcanvasCart?.querySelector('.offcanvas-footer')
        const newFooter = newDocument.querySelector('#offcanvas-cart .offcanvas-footer')
        if (currentFooter && newFooter) {
            currentFooter.replaceWith(newFooter)
        } else if (!currentFooter && newFooter && offcanvasCart) {
            offcanvasCart.appendChild(newFooter)
        } else if (currentFooter && !newFooter) {
            currentFooter.remove()
        }

        // Barra de envío gratis pegada al borde superior del cajón. Está fuera
        // del cuerpo y del pie, así que ninguno de los reemplazos anteriores la
        // alcanza: sin esto se quedaría con el importe de antes del cambio.
        const shipTop = document.querySelector('#ec2-ship-top')
        const newShipTop = newDocument.querySelector('#ec2-ship-top')
        if (shipTop && newShipTop) {
            shipTop.replaceWith(newShipTop)
        } else if (shipTop && !newShipTop) {
            shipTop.remove() // carrito vaciado, o la barra se apagó en los ajustes
        }

        // El panel de sugeridos de escritorio cuelga del wrapper, fuera del
        // cuerpo y del pie, asi que ninguno de los reemplazos anteriores lo
        // alcanza. En escritorio es el unico visible --cart.css oculta el que
        // va dentro del cajon-- y se pinta con el carrito que hubiera al
        // cargar la pagina: si estaba vacio, se quedaba vacio para siempre y
        // no se recomendaba nada hasta recargar.
        const sugeridos = document.querySelector('#offcanvas-cart-deskop-upsells')
        const nuevosSugeridos = newDocument.querySelector('#offcanvas-cart-deskop-upsells')
        if (sugeridos && nuevosSugeridos) {
            sugeridos.replaceWith(nuevosSugeridos)
        } else if (!sugeridos && nuevosSugeridos && offcanvasCart) {
            // Tiene que quedar como hermano inmediato: cart.css lo muestra con
            // el selector `#offcanvas-cart.show + #offcanvas-cart-deskop-upsells`.
            offcanvasCart.after(nuevosSugeridos)
        } else if (sugeridos && !nuevosSugeridos) {
            sugeridos.remove()
        }

        const newCartEl = newDocument.querySelector('#cart')
        if (cartPage && newCartEl) {
            const pageScroll = window.scrollY
            cartPage.replaceWith(newCartEl)
            window.scrollTo(0, pageScroll) // evita el salto de scroll al reemplazar #cart
        }

        if (typeof window.enigmaUpdateCartBadge === 'function') window.enigmaUpdateCartBadge()

        const cartRecs = document.querySelector('#enigma-cart-recs')
        const newCartRecs = newDocument.querySelector('#enigma-cart-recs')
        if (cartRecs && newCartRecs) {
            cartRecs.replaceWith(newCartRecs)
            if (typeof initFeaturedProducts === 'function') initFeaturedProducts()
        }

        window.dispatchEvent(new Event('updated.ecomify.cart'))

        const isAdd = response.url.includes('add.js')

        if (response.ok) {
            if (isAdd) {
                const alertAdd = offcanvasCart?.querySelector('#offcanvas-cart-alert-add')
                if (alertAdd) {
                    alertAdd.removeAttribute('hidden')
                    const data = await response.json()
                    if (data.items?.length > 1) {
                        const elemAlertItemsAdded = alertAdd.querySelector('[data-alert-items-added]')
                        if (elemAlertItemsAdded) {
                            elemAlertItemsAdded.textContent = elemAlertItemsAdded.textContent.replace('[count]', data.items.length)
                            elemAlertItemsAdded.removeAttribute('hidden')
                        }
                    } else {
                        alertAdd.querySelector('[data-alert-item-added]')?.removeAttribute('hidden')
                    }
                }

                // Abrir el cajon al agregar. Antes solo rebotaba el icono del
                // carrito y el cliente no tenia forma de saber que habia
                // pasado ni donde estaba el boton de pago.
                //
                // Va dentro de isAdd y de response.ok a proposito: un cambio
                // de cantidad o un borrado tocan /cart/change.js y no deben
                // abrir nada, y un alta rechazada por stock tampoco.
                // En la pagina /cart no hay cajon que abrir.
                if (offcanvasCart && !cartPage) {
                    bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart).show()
                }
            } else {
                offcanvasCart?.querySelector('#offcanvas-cart-alert-updated')?.removeAttribute('hidden')
            }

            // Página /cart (sin drawer): muestra su propio aviso
            if (cartPage) {
                const alertEl = document.querySelector('#cart-page-alert')
                if (alertEl) {
                    window.showCartPageAlert('success', isAdd ? alertEl.dataset.textAdded : alertEl.dataset.textUpdated)
                }
            }
        } else {
            const data = await response.json()
            const errorMsg = `${data.message} - ${data.description}`
            const alert = document.querySelector('#offcanvas-cart-alert-error')
            if (alert) {
                alert.querySelector('span').textContent = errorMsg
                alert.removeAttribute('hidden')
            }
            if (cartPage) window.showCartPageAlert('error', errorMsg)
        }

        if (offcanvasCart?.querySelector('#offcanvas-cart-empty')) {
            setTimeout(() => {
                bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart).hide()
            }, 1000)
        }

        if (offcanvasCart?.querySelector('#cart-shipping-rates')) {
            // eslint-disable-next-line no-new
            new Shopify.CountryProvinceSelector('shipping-rates-modal-country', 'shipping-rates-modal-province', {
                hideElement: 'shipping-rates-modal-province-wrapper'
            })
        }
    } finally {
        offcanvasCart?.classList.remove('loading')
        cartPage?.classList.remove('loading')
    }
}

// Quantity Inputs
window.onChangeCartQty = async (input) => {
    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: input.dataset.lineItemKey,
            quantity: input.value
        })
    })
    window.refreshCartContents(response)
}

// Remove Buttons
window.onRemoveCartItem = async (btn) => {
    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: btn.dataset.lineItemKey,
            quantity: 0
        })
    })
    window.refreshCartContents(response)
}

// Cart note - Save note via ajax
window.onSaveCartNote = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const note = btn.closest('#cart-note').querySelector('[name="note"]').value

    await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
    })

    btn.innerHTML = `✓ <span class="visually-hidden">${btn.dataset.textNoteSaved}</span>`

    setTimeout(() => {
        btn.innerHTML = btn.dataset.textBtnSave
    }, 4000)
}

// Checkout button - indicate loading on click (event delegation avoids timing issues with defer)
// NUNCA tocar innerHTML de este botón aquí.
//
// Antes se reemplazaba por un spinner, y eso destruye el nodo que el dedo
// acaba de tocar en mitad del propio evento. WebKit —o sea todo iOS, Safari y
// cualquier navegador del iPhone— abandona la acción por defecto cuando el
// elemento pulsado desaparece durante el clic: el formulario no se enviaba, no
// se navegaba al checkout y el spinner giraba para siempre. Con el texto
// envuelto en spans casi toda la superficie del botón era un hijo, así que
// fallaba casi cualquier toque.
//
// Ahora se AÑADE un spinner y se marca el botón con una clase. Añadir no
// destruye nada, el envío del formulario sigue su curso.
document.addEventListener('click', function(e) {
    const btn = e.target.closest('.btn-checkout')
    if (!btn) return

    if (!btn.querySelector('.ec2-checkout-spin')) {
        const spin = document.createElement('span')
        spin.className = 'ec2-checkout-spin'
        spin.setAttribute('role', 'status')
        spin.setAttribute('aria-label', 'Procesando')
        btn.appendChild(spin)
    }
    btn.classList.add('is-loading')

    // Red de seguridad: si el clic no llega a navegar (carrito vacío, términos
    // sin aceptar, la red se cae), el spinner se quedaría girando para siempre.
    clearTimeout(btn.__checkoutTimer)
    btn.__checkoutTimer = setTimeout(() => window.restoreCheckoutButtons(), 12000)
})

// El marcado del tema original llama a onClickCheckoutBtn(this) en linea, asi
// que la funcion tiene que existir o cada clic lanza un ReferenceError.
//
// No hace nada a proposito: del spinner ya se encarga el listener delegado de
// arriba, que ademas es el seguro en iOS. La version original de esta funcion
// hacia btn.innerHTML = spinner, que destruye el nodo pulsado y deja el
// checkout colgado en Safari. Se conserva el nombre, no el comportamiento.
window.onClickCheckoutBtn = () => {}

window.restoreCheckoutButtons = () => {
    document.querySelectorAll('.btn-checkout.is-loading').forEach(btn => {
        clearTimeout(btn.__checkoutTimer)
        btn.classList.remove('is-loading')
        btn.disabled = false
    })
}

// Volver desde el checkout con el botón atrás: el navegador restaura la página
// tal como quedó, o sea con el spinner puesto, y el botón parecía cargando sin
// fin. pageshow cubre tanto la restauración desde la caché (persisted) como una
// carga normal, donde no hay nada que restaurar y no hace nada.
window.addEventListener('pageshow', () => window.restoreCheckoutButtons())

// Cart Goal - Animate width
const initCartGoal = () => {
    const progressBar = document.querySelector('#cart-goal .progress-bar')
    if (progressBar) {
        setTimeout(() => {
            progressBar.style.width = progressBar.dataset.width
        }, 250)
    }
}
initCartGoal()

window.addEventListener('updated.ecomify.cart', () => {
    initCartGoal()
})

// Cart Goal - Free product
const initCartGoalFreeProduct = async () => {
    const cartGoal = document.querySelector('#cart-goal')
    if (!cartGoal) return

    const freeProductHandle = cartGoal.dataset.freeProductHandle
    if (!freeProductHandle.length) return

    const goalCompleted = cartGoal.dataset.goalCompleted === 'true'
    let isFreeProductInCart = false

    document.querySelectorAll('[data-cart-line-item]').forEach(elem => {
        if (elem.dataset.productHandle === freeProductHandle) {
            isFreeProductInCart = true
        }
    })

    const freeProductVariantId = Number(cartGoal.dataset.freeProductVariantId)

    if (goalCompleted) {
        if (!isFreeProductInCart) {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: freeProductVariantId,
                        quantity: 1
                    }]
                })
            })
            window.refreshCartContents(response)
        }
    }

}
initCartGoalFreeProduct()

window.addEventListener('updated.ecomify.cart', () => {
    initCartGoalFreeProduct()
})

// Summary card on the cart page - sticky on desktop
const initStickySummaryCard = () => {
    const card = document.querySelector('#cart-summary')

    if (!card) return

    if (window.matchMedia('(max-width: 991px)').matches) return

    const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
    const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0

    card.style.position = 'sticky'
    card.style.top = `${navbarHeight + announcementBarHeight + 20}px`
}
initStickySummaryCard()

window.addEventListener('updated.ecomify.cart', () => {
    initStickySummaryCard()
})

// Generate Shipping rates
// https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates
window.generateShippingRates = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const wrapper = document.querySelector('#cart-shipping-rates-collapse')

    wrapper.querySelector('#shipping-rates-modal-alert-danger').innerHTML = ''
    wrapper.querySelector('#shipping-rates-modal-alert-danger').setAttribute('hidden', 'hidden')
    wrapper.querySelector('#shipping-rates-modal-alert-warning').innerHTML = ''
    wrapper.querySelector('#shipping-rates-modal-alert-warning').setAttribute('hidden', 'hidden')
    wrapper.querySelector('#shipping-rates-modal-alert-success').innerHTML = ''
    wrapper.querySelector('#shipping-rates-modal-alert-success').setAttribute('hidden', 'hidden')

    const country = wrapper.querySelector('#shipping-rates-modal-country').value
    const province = wrapper.querySelector('#shipping-rates-modal-province').value
    const zip = wrapper.querySelector('#shipping-rates-modal-zip').value

    const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, {
        method: 'POST'
    })

    if (prepareResponse.ok) {
        const asyncRespose = await fetch(`/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`)

        const data = await asyncRespose.json()

        let html = ''

        if (data.shipping_rates.length) {
            data.shipping_rates.forEach(elem => {
                html += `
                    <li>
                        <strong>${elem.presentment_name}</strong>: ${elem.price} ${elem.currency}
                    </li>
                `
            })

            wrapper.querySelector('#shipping-rates-modal-alert-success').innerHTML = `
                <ul class="ps-5 mb-0">
                    ${html}
                </ul>
            `
            wrapper.querySelector('#shipping-rates-modal-alert-success').removeAttribute('hidden')
        } else {
            wrapper.querySelector('#shipping-rates-modal-alert-warning').innerHTML = `
                <p class="mb-0">
                    ${wrapper.dataset.textNoResults}
                </p>
            `
            wrapper.querySelector('#shipping-rates-modal-alert-warning').removeAttribute('hidden')
        }
    } else {
        const data = await prepareResponse.json()

        let html = ''

        for (const [key, value] of Object.entries(data)) {
            html += `
                <li>
                    <strong>${key}</strong>: ${value.toString()}
                </li>
            `
        }

        wrapper.querySelector('#shipping-rates-modal-alert-danger').innerHTML = `
            <ul class="ps-5 mb-0">
                ${html}
            </ul>
        `
        wrapper.querySelector('#shipping-rates-modal-alert-danger').removeAttribute('hidden')
    }

    btn.innerHTML = btn.dataset.text
}

// Offcanvas cart - fix scrolling for callapses
const fixScrollingOffcanvasCollapses = () => {
    document.querySelectorAll('#offcanvas-cart [data-bs-toggle="collapse"]').forEach(elem => {
        elem.addEventListener('click', () => {
            setTimeout(() => {
                const offcanvasBody = document.querySelector('#offcanvas-cart .offcanvas-body')
                offcanvasBody.scroll({ top: offcanvasBody.scrollHeight, behavior: 'smooth' })
            }, 250)
        })
    })
}
fixScrollingOffcanvasCollapses()

window.addEventListener('updated.ecomify.cart', () => {
    fixScrollingOffcanvasCollapses()
})

// Upgrade to subscription
window.onChangeCartUpgradeToSub = async (select) => {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: select.dataset.lineItemKey,
            quantity: 0
        })
    })

    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                quantity: Number(select.dataset.quantity),
                id: Number(select.dataset.variantId),
                selling_plan: Number(select.value)
            }]
        })
    })

    window.refreshCartContents(response)
}

// Gift Wrap
window.onChangeCartGiftWrap = async (input) => {
    let response

    if (input.checked) {
        response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    quantity: 1,
                    id: Number(input.value)
                }]
            })
        })
    } else {
        response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: input.dataset.lineItemKey,
                quantity: 0
            })
        })
    }
    window.refreshCartContents(response)
}

// Cart Min Order
const initCartMinOrder = () => {
    const wrapper = document.querySelector('#cart-min-order')
    if (!wrapper) return

    if (wrapper.dataset.goalReached === 'false') {
        wrapper.closest('form').querySelector('.btn-checkout').disabled = true
    }
}
initCartMinOrder()
window.addEventListener('updated.ecomify.cart', () => {
    initCartMinOrder()
})

// Shipping protection
const initCartShippingProtection = async () => {
    if (!document.querySelector('[data-shipping-protection-enabled="true"]')) return
    if (!document.querySelector('[data-shipping-protection-auto-init="true"]')) return

    if (!window.localStorage.getItem('ecomify-shipping-protection-init')) {
        const variantId = Number(document.querySelector('[data-shipping-protection-variant-id]').dataset.shippingProtectionVariantId)

        // Sin producto configurado en los ajustes el atributo llega vacio,
        // Number('') da 0 y el POST responde 422. Peor todavia: seguia
        // adelante y llamaba a refreshCartContents, que descarga y reparsea la
        // pagina entera para nada, en la primera visita de CADA usuario.
        // Aparecia en la consola de PageSpeed como "/cart/add.js 422".
        if (!variantId) return

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    quantity: 1,
                    id: variantId
                }]
            })
        })

        window.refreshCartContents(response)
        window.localStorage.setItem('ecomify-shipping-protection-init', true)
    }
}
initCartShippingProtection()

window.onChangeCartShippingProtection = async (input) => {
    let response

    if (input.checked) {
        response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    quantity: 1,
                    id: Number(input.value)
                }]
            })
        })
    } else {
        response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: input.dataset.lineItemKey,
                quantity: 0
            })
        })
    }
    window.refreshCartContents(response)
}

// Variant switcher
window.onChangeCartLineItemVariant = async (select) => {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: select.dataset.lineItemKey,
            quantity: 0
        })
    })

    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                quantity: Number(select.dataset.quantity),
                id: Number(select.value),
                selling_plan: select.dataset.sellingPlanId.length
                    ? Number(select.dataset.sellingPlanId)
                    : null
            }]
        })
    })

    window.refreshCartContents(response)
}


// Cart Discount — global scope (onclick en HTML lo necesita disponible siempre)
window.onCartDiscountClick = async (btn) => {
    const wrapper = document.querySelector('#cart-discount')
    const input = wrapper?.querySelector('.form-control')
    const discountCode = input?.value?.trim()

    if (!discountCode) return

    const originalHTML = btn.innerHTML
    btn.disabled = true
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width:1rem;height:1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    // Estado del descuento ANTES de aplicar (para detectar si el cupón realmente sirvió)
    const before = { total: 0, titles: [] }
    try {
        const c = await (await fetch('/cart.js')).json()
        before.total = c.total_discount || 0
        before.titles = (c.cart_level_discount_applications || []).map(d => d.title)
    } catch (e) { /* si falla, seguimos igual */ }

    try {
        // Registra el descuento en la sesión del carrito
        const response = await fetch(`/discount/${encodeURIComponent(discountCode)}`)
        // Refresca el carrito en el sitio (sin recarga completa → mucho más rápido)
        if (typeof window.refreshCartContents === 'function') {
            await window.refreshCartContents(response)
        }

        // Verifica si el descuento REALMENTE quedó aplicado
        const after = await (await fetch('/cart.js')).json()
        const afterTitles = (after.cart_level_discount_applications || []).map(d => d.title)
        const newTitle = afterTitles.find(t => !before.titles.includes(t))
        const applied = (after.total_discount || 0) > before.total || afterTitles.length > before.titles.length

        if (typeof window.showCartPageAlert === 'function') {
            if (applied) {
                window.showCartPageAlert('success', newTitle ? `Cupón aplicado: ${newTitle}` : 'Cupón aplicado')
            } else {
                window.showCartPageAlert('error', 'Cupón inválido o expirado')
            }
        } else if (!applied) {
            // Fallback sin toast: recarga para reflejar el estado real
            window.location.href = '/cart'
        }
    } catch (e) {
        if (typeof window.showCartPageAlert === 'function') {
            window.showCartPageAlert('error', 'No se pudo aplicar el cupón. Intenta de nuevo.')
        }
    } finally {
        btn.disabled = false
        btn.innerHTML = originalHTML
    }
}

// Drena la cola de llamadas que llegaron antes de que este archivo cargara
if (typeof window.__cartReady === 'function') window.__cartReady()
